// Update VERTICAL_NAME to the new vertical name
export const VERTICAL_NAME = 'HELLO-REACT';
